import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

import { IncidentsQueuePayloadConfig } from '../../../configuration'
import { addIncidentAndUpdatePossession } from '../../configuration'

export const incidentsQueuePayloadConfig: IncidentsQueuePayloadConfig<RugbyLeagueIncidentId> =
  {
    [RugbyLeagueIncidentId.TackleMade]: {
      addIncident: (payload, queue, { oppositeParticipant }) => {
        queue.addIncident({
          ...payload,
          participant_team_id: oppositeParticipant?.id,
          incident_id: RugbyLeagueIncidentId.TackleMade,
        })
      },
    },
    [RugbyLeagueIncidentId.SubstitutionIn]: {
      addIncident: (payload, queue) => {
        const substitutionOutUuid = queue.addIncident({
          ...payload,
          incident_id: RugbyLeagueIncidentId.SubstitutionOut,
        })
        queue.addIncident(
          {
            ...payload,
            incident_id: RugbyLeagueIncidentId.SubstitutionIn,
          },
          substitutionOutUuid,
        )
      },
    },
    [RugbyLeagueIncidentId.Kick]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyLeagueIncidentId.Offload]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyLeagueIncidentId.Lineout]: {
      addIncident: addIncidentAndUpdatePossession,
    },
    [RugbyLeagueIncidentId.Scrum]: {
      addIncident: addIncidentAndUpdatePossession,
    },
  }
